import React from 'react';
import MyContextProvider from './contexts/MyContext';
import Dashboard from './page/Dashboard';
function App() { return (<MyContextProvider><Dashboard/></MyContextProvider>);}export default App;